import React from 'react'

export default function ContactSection({
  title,
  description,
  email,
  facebookLink,
}) {
  return (
    <section
      id="contact-section"
      data-scroll-index="8"
      className="main-section"
    >
      {/*<!-- Overlay Color -->*/}
      <div className="gradient-color overlay" />

      <div className="container">
        {/*<!--Title-->*/}
        <h4 className="reflection-text reflection-text-white p-b-2">{title}</h4>

        {/*<!-- Description -->*/}
        <p className="p-t-1 desc">{description}</p>
        <p className="p-t-1 desc">
          <a href={`mailto:${email}`}>{email}</a>
        </p>
        <div className="social-icons p-b-1">
          <a href={facebookLink} target="_blank">
            <i className="fa fa-facebook shadow-button waves-effect waves-light waves-circle blue" />
          </a>
        </div>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./src/components/Sections/ContactSection.js